import { getNamespacedResource } from "SharedStores/util";
import { IS_DEBUG_BUILD } from "Util/util";

const PROJECT_FORM_CONTROLLER_NAMESPACE = "projectFormController";
const SUBMIT_PROJECT = "submitProject";
const CONFIRM_ADMIN_SAVE = "confirmAdminSave";
const SAVE_FORM_DATA = "saveFormData";
const SAVE_CONDITIONAL_DEPS = "saveConditionalDependencies";
const CALC_PV_OUTPUT = "calcPvOutput";
const CALC_ENERGY_STORAGE_OUTPUT = "calcEnergyStorageOutput";
const GET_INCENTIVE_DESIGN_OPTIONS = "getIncentiveDesignOptions";
const UPDATE_INCENTIVE_SELECTOR_CONDITIONAL_DEPS = "updateIncentiveSelectorConditionalDependencies";
const CALC_INCENTIVE = "calcIncentive";
const OVERRIDE_INCENTIVE = "overrideIncentive";
const GENERATE_DOCUMENT = "generateDocument";
const UPLOAD_ATTACHMENT = "uploadAttachment";
const UPLOAD_ATTACHMENT_INTERNAL = "uploadAttachmentInternal";
const REMOVE_ATTACHMENT = "removeAttachment";
const SET_SIGNATURE_CHOICE = "setSignatureChoice";
const GENERATE_SIGNATURE_DOCUMENT = "generateSignatureDocument";
const REQUEST_SIGNATURES = "requestSignatures";
const CANCEL_ALL_SIGNATURES = "cancelAllSignatures";
const CANCEL_INCOMPLETE_SIGNATURES = "cancelIncompleteSignatures";
const RESEND_SIGNATURE_NOTIFICATIONS = "resendSignatureNotifications";
const REQUEST_SIGNATURES_V2 = "requestSignaturesV2";
const RESEND_ESIGNATURE_NOTIFICATIONS_V2 = "resendESignatureNotificationsV2";
const VOID_SIGNATURES_V2 = "voidSignaturesV2";
const FETCH_ENVELOPE_UPDATE = "fetchEnvelopeUpdate";
const CREATE_WET_SIGN_ENVELOPE = "createWetSignEnvelope";
const GENERATE_ENVELOPE_ITEM_DOCUMENT = "generateEnvelopeItemDocument";
const UPLOAD_WET_SIGN_ENVELOPE_ITEM = "uploadWetSignEnvelopeItem";
const REMOVE_WET_SIGN_ENVELOPE_ITEM = "removeWetSignEnvelopeItem";
const VIEW_ENVELOPE_ITEM = "viewEnvelopeItem";
const VIEW_COMPLETED_ENVELOPE_ATTACHMENT = "viewCompletedEnvelopeAttachment";
const VIEW_WET_SIGN_ENVELOPE_ITEM = "viewWetSignEnvelopeItem";
const COMPLETE_WET_SIGN_ENVELOPE = "completeWetSignEnvelope";
const START_OVER_ENVELOPE = "startOverEnvelope";
const RETRIEVE_SENSITIVE_DATA = "retrieveSensitiveData";
const SHOW_MFA_DIALOG = "showMfaDialog";
const ADMIN_CONFIRM_SAVE_FORM_DATA = "adminConfirmSaveFormData";
const CALL_WEB_ADAPTER = "callCustomization";
const WAIT_FOR_ACTIVE_SAVES = "waitForActiveSaves";
const REGISTER_SAVE_PROMISE = "registerSavePromise";
const UPLOAD_TABLE_FILE = "uploadTableFile";
const IMPORT_PROJECT_TABLE_ROWS = "importProjectTableRows";
const CANCEL_PROJECT_TABLE_IMPORT = "cancelProjectTableImport";
const ADD_PROJECT_TABLE_ROW = "addProjectTableRow";
const GET_PROJECT_TABLE_DATA = "getProjectTableData";
const EDIT_PROJECT_TABLE_ROW = "editProjectTableRow";
const VIEW_PROJECT_TABLE_ROW = "viewProjectTableRow";
const REMOVE_PROJECT_TABLE_ROW = "removeProjectTableRow";
const FIND_PROJECT_TABLE_EXISTING_PROJECT = "findProjectTableExistingProject";
const ADD_PROJECT_TABLE_EXISTING_PROJECT = "addProjectTableExistingProject";
const GET_CUSTOM_LIST_DATA_FULL = "getCustomListDataFull";
const GET_CUSTOM_LIST_DATA_INITIAL = "getCustomListDataInitial";
const GET_CUSTOM_LIST_DATA_CHILDREN = "getCustomListDataChildren";
const GET_ADDRESS_AUTOCOMPLETE = "getAddressAutocomplete";
const GET_ADDRESS_EXPANSION_AUTOCOMPLETE = "getAddressExpansionAutocomplete";
const GET_ADDRESS_COUNTY_AUTOCOMPLETE = "getAddressCountyAutocomplete";
const GET_LOCATION_SAS_TOKEN = "getLocationSasToken";

const PROJECT_FORM_CONTROLLER_TYPES = {
    actions: {
        [SUBMIT_PROJECT]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, SUBMIT_PROJECT),
        [CONFIRM_ADMIN_SAVE]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, CONFIRM_ADMIN_SAVE),
        [SAVE_FORM_DATA]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, SAVE_FORM_DATA),
        [SAVE_CONDITIONAL_DEPS]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, SAVE_CONDITIONAL_DEPS),
        [CALC_PV_OUTPUT]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, CALC_PV_OUTPUT),
        [CALC_ENERGY_STORAGE_OUTPUT]: getNamespacedResource(
            PROJECT_FORM_CONTROLLER_NAMESPACE,
            CALC_ENERGY_STORAGE_OUTPUT
        ),
        [GET_INCENTIVE_DESIGN_OPTIONS]: getNamespacedResource(
            PROJECT_FORM_CONTROLLER_NAMESPACE,
            GET_INCENTIVE_DESIGN_OPTIONS
        ),
        [UPDATE_INCENTIVE_SELECTOR_CONDITIONAL_DEPS]: getNamespacedResource(
            PROJECT_FORM_CONTROLLER_NAMESPACE,
            UPDATE_INCENTIVE_SELECTOR_CONDITIONAL_DEPS
        ),
        [CALC_INCENTIVE]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, CALC_INCENTIVE),
        [OVERRIDE_INCENTIVE]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, OVERRIDE_INCENTIVE),
        [GENERATE_DOCUMENT]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, GENERATE_DOCUMENT),
        [UPLOAD_ATTACHMENT]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, UPLOAD_ATTACHMENT),
        [UPLOAD_ATTACHMENT_INTERNAL]: getNamespacedResource(
            PROJECT_FORM_CONTROLLER_NAMESPACE,
            UPLOAD_ATTACHMENT_INTERNAL
        ),
        [REMOVE_ATTACHMENT]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, REMOVE_ATTACHMENT),
        [SET_SIGNATURE_CHOICE]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, SET_SIGNATURE_CHOICE),
        [GENERATE_SIGNATURE_DOCUMENT]: getNamespacedResource(
            PROJECT_FORM_CONTROLLER_NAMESPACE,
            GENERATE_SIGNATURE_DOCUMENT
        ),
        [REQUEST_SIGNATURES]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, REQUEST_SIGNATURES),
        [CANCEL_ALL_SIGNATURES]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, CANCEL_ALL_SIGNATURES),
        [CANCEL_INCOMPLETE_SIGNATURES]: getNamespacedResource(
            PROJECT_FORM_CONTROLLER_NAMESPACE,
            CANCEL_INCOMPLETE_SIGNATURES
        ),
        [RESEND_SIGNATURE_NOTIFICATIONS]: getNamespacedResource(
            PROJECT_FORM_CONTROLLER_NAMESPACE,
            RESEND_SIGNATURE_NOTIFICATIONS
        ),
        [REQUEST_SIGNATURES_V2]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, REQUEST_SIGNATURES_V2),
        [RESEND_ESIGNATURE_NOTIFICATIONS_V2]: getNamespacedResource(
            PROJECT_FORM_CONTROLLER_NAMESPACE,
            RESEND_ESIGNATURE_NOTIFICATIONS_V2
        ),
        [VOID_SIGNATURES_V2]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, VOID_SIGNATURES_V2),
        [FETCH_ENVELOPE_UPDATE]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, FETCH_ENVELOPE_UPDATE),
        [CREATE_WET_SIGN_ENVELOPE]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, CREATE_WET_SIGN_ENVELOPE),
        [GENERATE_ENVELOPE_ITEM_DOCUMENT]: getNamespacedResource(
            PROJECT_FORM_CONTROLLER_NAMESPACE,
            GENERATE_ENVELOPE_ITEM_DOCUMENT
        ),
        [UPLOAD_WET_SIGN_ENVELOPE_ITEM]: getNamespacedResource(
            PROJECT_FORM_CONTROLLER_NAMESPACE,
            UPLOAD_WET_SIGN_ENVELOPE_ITEM
        ),
        [REMOVE_WET_SIGN_ENVELOPE_ITEM]: getNamespacedResource(
            PROJECT_FORM_CONTROLLER_NAMESPACE,
            REMOVE_WET_SIGN_ENVELOPE_ITEM
        ),
        [VIEW_ENVELOPE_ITEM]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, VIEW_ENVELOPE_ITEM),
        [VIEW_COMPLETED_ENVELOPE_ATTACHMENT]: getNamespacedResource(
            PROJECT_FORM_CONTROLLER_NAMESPACE,
            VIEW_COMPLETED_ENVELOPE_ATTACHMENT
        ),
        [VIEW_WET_SIGN_ENVELOPE_ITEM]: getNamespacedResource(
            PROJECT_FORM_CONTROLLER_NAMESPACE,
            VIEW_WET_SIGN_ENVELOPE_ITEM
        ),
        [COMPLETE_WET_SIGN_ENVELOPE]: getNamespacedResource(
            PROJECT_FORM_CONTROLLER_NAMESPACE,
            COMPLETE_WET_SIGN_ENVELOPE
        ),
        [START_OVER_ENVELOPE]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, START_OVER_ENVELOPE),
        [CALL_WEB_ADAPTER]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, CALL_WEB_ADAPTER),
        [RETRIEVE_SENSITIVE_DATA]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, RETRIEVE_SENSITIVE_DATA),
        [SHOW_MFA_DIALOG]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, SHOW_MFA_DIALOG),
        [ADMIN_CONFIRM_SAVE_FORM_DATA]: getNamespacedResource(
            PROJECT_FORM_CONTROLLER_NAMESPACE,
            ADMIN_CONFIRM_SAVE_FORM_DATA
        ),
        [WAIT_FOR_ACTIVE_SAVES]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, WAIT_FOR_ACTIVE_SAVES),
        [REGISTER_SAVE_PROMISE]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, REGISTER_SAVE_PROMISE),
        [UPLOAD_TABLE_FILE]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, UPLOAD_TABLE_FILE),
        [IMPORT_PROJECT_TABLE_ROWS]: getNamespacedResource(
            PROJECT_FORM_CONTROLLER_NAMESPACE,
            IMPORT_PROJECT_TABLE_ROWS
        ),
        [CANCEL_PROJECT_TABLE_IMPORT]: getNamespacedResource(
            PROJECT_FORM_CONTROLLER_NAMESPACE,
            CANCEL_PROJECT_TABLE_IMPORT
        ),
        [ADD_PROJECT_TABLE_ROW]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, ADD_PROJECT_TABLE_ROW),
        [GET_PROJECT_TABLE_DATA]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, GET_PROJECT_TABLE_DATA),
        [EDIT_PROJECT_TABLE_ROW]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, EDIT_PROJECT_TABLE_ROW),
        [VIEW_PROJECT_TABLE_ROW]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, VIEW_PROJECT_TABLE_ROW),
        [REMOVE_PROJECT_TABLE_ROW]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, REMOVE_PROJECT_TABLE_ROW),
        [FIND_PROJECT_TABLE_EXISTING_PROJECT]: getNamespacedResource(
            PROJECT_FORM_CONTROLLER_NAMESPACE,
            FIND_PROJECT_TABLE_EXISTING_PROJECT
        ),
        [ADD_PROJECT_TABLE_EXISTING_PROJECT]: getNamespacedResource(
            PROJECT_FORM_CONTROLLER_NAMESPACE,
            ADD_PROJECT_TABLE_EXISTING_PROJECT
        ),
        [GET_CUSTOM_LIST_DATA_FULL]: getNamespacedResource(
            PROJECT_FORM_CONTROLLER_NAMESPACE,
            GET_CUSTOM_LIST_DATA_FULL
        ),
        [GET_CUSTOM_LIST_DATA_INITIAL]: getNamespacedResource(
            PROJECT_FORM_CONTROLLER_NAMESPACE,
            GET_CUSTOM_LIST_DATA_INITIAL
        ),
        [GET_CUSTOM_LIST_DATA_CHILDREN]: getNamespacedResource(
            PROJECT_FORM_CONTROLLER_NAMESPACE,
            GET_CUSTOM_LIST_DATA_CHILDREN
        ),
        [GET_ADDRESS_AUTOCOMPLETE]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, GET_ADDRESS_AUTOCOMPLETE),
        [GET_ADDRESS_EXPANSION_AUTOCOMPLETE]: getNamespacedResource(
            PROJECT_FORM_CONTROLLER_NAMESPACE,
            GET_ADDRESS_EXPANSION_AUTOCOMPLETE
        ),
        [GET_ADDRESS_COUNTY_AUTOCOMPLETE]: getNamespacedResource(
            PROJECT_FORM_CONTROLLER_NAMESPACE,
            GET_ADDRESS_COUNTY_AUTOCOMPLETE
        ),
        [GET_LOCATION_SAS_TOKEN]: getNamespacedResource(PROJECT_FORM_CONTROLLER_NAMESPACE, GET_LOCATION_SAS_TOKEN)
    }
};

export {
    PROJECT_FORM_CONTROLLER_NAMESPACE,
    PROJECT_FORM_CONTROLLER_TYPES,
    GENERATE_DOCUMENT,
    GENERATE_SIGNATURE_DOCUMENT,
    UPLOAD_ATTACHMENT,
    UPLOAD_ATTACHMENT_INTERNAL,
    REMOVE_ATTACHMENT,
    SET_SIGNATURE_CHOICE,
    REQUEST_SIGNATURES,
    CANCEL_ALL_SIGNATURES,
    CANCEL_INCOMPLETE_SIGNATURES,
    RESEND_SIGNATURE_NOTIFICATIONS,
    REQUEST_SIGNATURES_V2,
    RESEND_ESIGNATURE_NOTIFICATIONS_V2,
    VOID_SIGNATURES_V2,
    FETCH_ENVELOPE_UPDATE,
    CREATE_WET_SIGN_ENVELOPE,
    GENERATE_ENVELOPE_ITEM_DOCUMENT,
    UPLOAD_WET_SIGN_ENVELOPE_ITEM,
    REMOVE_WET_SIGN_ENVELOPE_ITEM,
    VIEW_ENVELOPE_ITEM,
    VIEW_COMPLETED_ENVELOPE_ATTACHMENT,
    VIEW_WET_SIGN_ENVELOPE_ITEM,
    COMPLETE_WET_SIGN_ENVELOPE,
    START_OVER_ENVELOPE,
    CALC_PV_OUTPUT,
    CALC_ENERGY_STORAGE_OUTPUT,
    GET_INCENTIVE_DESIGN_OPTIONS,
    UPDATE_INCENTIVE_SELECTOR_CONDITIONAL_DEPS,
    CALC_INCENTIVE,
    OVERRIDE_INCENTIVE,
    CALL_WEB_ADAPTER,
    RETRIEVE_SENSITIVE_DATA,
    CONFIRM_ADMIN_SAVE,
    SAVE_FORM_DATA,
    SAVE_CONDITIONAL_DEPS,
    SUBMIT_PROJECT,
    SHOW_MFA_DIALOG,
    ADMIN_CONFIRM_SAVE_FORM_DATA,
    WAIT_FOR_ACTIVE_SAVES,
    REGISTER_SAVE_PROMISE,
    UPLOAD_TABLE_FILE,
    IMPORT_PROJECT_TABLE_ROWS,
    CANCEL_PROJECT_TABLE_IMPORT,
    ADD_PROJECT_TABLE_ROW,
    GET_PROJECT_TABLE_DATA,
    EDIT_PROJECT_TABLE_ROW,
    VIEW_PROJECT_TABLE_ROW,
    REMOVE_PROJECT_TABLE_ROW,
    FIND_PROJECT_TABLE_EXISTING_PROJECT,
    ADD_PROJECT_TABLE_EXISTING_PROJECT,
    GET_CUSTOM_LIST_DATA_FULL,
    GET_CUSTOM_LIST_DATA_INITIAL,
    GET_CUSTOM_LIST_DATA_CHILDREN,
    GET_ADDRESS_AUTOCOMPLETE,
    GET_ADDRESS_EXPANSION_AUTOCOMPLETE,
    GET_ADDRESS_COUNTY_AUTOCOMPLETE,
    GET_LOCATION_SAS_TOKEN
};

function logIfMissingControllerAction(controller, actionName) {
    if (!controller[actionName]) {
        console.error(`controller action [${actionName}] is missing`);
    }
}

export function createProjectFormControllerModule(controller) {
    const actions = {};
    for (const actionName in PROJECT_FORM_CONTROLLER_TYPES.actions) {
        if (PROJECT_FORM_CONTROLLER_TYPES.actions.hasOwnProperty(actionName)) {
            //verify controller actions when in debug.
            if (IS_DEBUG_BUILD) {
                logIfMissingControllerAction(controller, actionName);
            }
            actions[actionName] = controller[actionName];
        }
    }

    return {
        namespaced: true,
        actions
    };
}
